import React, { useState, useLayoutEffect, useEffect } from 'react';
import { useSettings, constants } from '@atlas/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

const { SPORT_SERVICE } = constants;

const EVENT_REGEX = /(\d+)$/;
const dataConfigIds = {
  [SPORT_SERVICE.LIVE]: 794,
  [SPORT_SERVICE.PREMATCH]: 795,
};

const trackerId = 'trackerId';

const Tracker = ({ externalId, sportService }) => {
  const { lang } = useSettings();
  const [error, setError] = useState(false);
  const [tracker, setTracker] = useState(null);

  useLayoutEffect(() => {
    setTracker(
      new STATSCORE.LSP.Generator().create(
        `#${trackerId}`, // id of parent div
        trackerId, // tracker name
        {
          lang,
          timezone: 'Local',
          useMappedId: '1', // 1 - to use lsport's ids, 0 - to use statscore's ids
        },
      ),
    );
  }, []);

  useEffect(() => {
    const errorHandler = () => {
      setError(true);
    };
    const eventName = `statscore.livematchpro.${trackerId}.error`;
    window.addEventListener(eventName, errorHandler);

    return () => window.removeEventListener(eventName, errorHandler);
  }, []);

  useEffect(() => {
    const widgetMatchId = externalId && externalId.match(EVENT_REGEX)[0];
    if (!tracker || !widgetMatchId) {
      return;
    }

    const dataConfigId = dataConfigIds[sportService];

    setError(false);

    try {
      tracker
        .setEvent(widgetMatchId) // id of the match mapped from lsport
        .setConfig(dataConfigId) // personal id of the customer (us). Different for live and prematch
        .setLang(lang)
        .useMappedEventId() // to set useMappedId to 1 (lsport's ids)
        .refresh();
    } catch (e) {
      console.log('e', e);
    }
  }, [externalId, lang, tracker]);

  const trackerClassName = cx(['details-event-tracker', error && 'details-event-tracker-error']);

  return <div id={trackerId} className={trackerClassName} />;
};

Tracker.propTypes = {
  externalId: PropTypes.number,
  sportService: PropTypes.number,
};

export default Tracker;
